var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute close-btn z-20"},[_c('img',{staticClass:" rounded-full p-2 bg-white w-10 h-10 cursor-pointer",attrs:{"src":require("./img/close.svg"),"alt":"Close"},on:{"click":function($event){return _vm.$emit('close')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }